import loadable from '@loadable/component';
export const manifest = {
  CpasCookiesProvider: {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "CpasCookiesProvider";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "CpasCookiesProvider" */
          './cookie-provider'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./cookie-provider");
            }

            return eval('require.resolve')("./cookie-provider");
          }

        }, {
          resolveComponent: m => m.CpasCookiesProvider
        })
      }
    }
  },
  'CpasCookiesProvider.Close': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "CpasCookiesProviderClose";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "CpasCookiesProviderClose" */
          './close'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./close");
            }

            return eval('require.resolve')("./close");
          }

        }, {
          resolveComponent: m => m.CpasCookiesProviderClose
        })
      }
    }
  }
};